// AIDEV-NOTE: Specific error types for better error boundary handling

export abstract class PaywallError extends Error {
  abstract readonly code: string;
  abstract readonly userMessage: string;
  
  constructor(message: string, public readonly cause?: Error) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class PaywallAuthError extends PaywallError {
  readonly code = "PAYWALL_AUTH_FAILED";
  readonly userMessage = "Authentication failed. Please try again or contact support if the problem persists.";
}

export class PaywallInitializationError extends PaywallError {
  readonly code = "PAYWALL_INIT_FAILED";
  readonly userMessage = "Failed to initialize paywall. Please try again or contact support if the problem persists.";
}

export class PaywallUnknownError extends PaywallError {
  readonly code = "PAYWALL_UNKNOWN_ERROR";
  readonly userMessage = "An unexpected error occurred. Please try again or contact support if the problem persists.";
}